module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-pickwick-intro-card1.2@2x.cab6450e.jpg";